/**
 * Converts any Firestore timestamp, JS Date, or unix-seconds object
 * into a compact relative string for the first 7 days, then an absolute date.
 *
 * Examples:
 *   < 1 min   → "just now"
 *   1–59 min  → "3m"
 *   1–23 hr   → "3hr"
 *   1–6 days  → "2d"
 *   ≥ 7 days, same year  → "Mar 4"
 *   ≥ 7 days, past year  → "Mar 4, 2024"
 */
export function formatTimestamp(raw) {
  if (!raw) return '';

  let date;
  if (raw instanceof Date) {
    date = raw;
  } else if (typeof raw.toDate === 'function') {
    date = raw.toDate();
  } else if (typeof raw.seconds === 'number') {
    date = new Date(raw.seconds * 1000);
  } else {
    date = new Date(raw);
  }

  const now = new Date();
  const diffMs = now - date;
  const diffSec = Math.floor(diffMs / 1000);
  const diffMin = Math.floor(diffSec / 60);
  const diffHr = Math.floor(diffMin / 60);
  const diffDay = Math.floor(diffHr / 24);

  if (diffSec < 60) return 'just now';
  if (diffMin < 60) return `${diffMin}m`;
  if (diffHr < 24) return `${diffHr}hr`;
  if (diffDay < 7) return `${diffDay}d`;

  const sameYear = date.getFullYear() === now.getFullYear();
  return date.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    ...(sameYear ? {} : { year: 'numeric' }),
  });
}
